import { render, staticRenderFns } from "./ownerDetail.vue?vue&type=template&id=41e5f851&scoped=true"
import script from "./ownerDetail.vue?vue&type=script&lang=js"
export * from "./ownerDetail.vue?vue&type=script&lang=js"
import style0 from "./ownerDetail.vue?vue&type=style&index=0&id=41e5f851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e5f851",
  null
  
)

export default component.exports